import React from 'react';
import { ConfirmImportCsv } from '@components/forms/import-csv/confirm-import';
import ReviewImport from '@components/forms/import-csv/review-import';
import { SelectType } from '@components/forms/import-csv/select-type';
import { STEP_CONFIRM, STEP_INFO, STEP_SELECT_TYPE } from '@constants/process-steps';

import { ImportCsvStepsProps } from './process-import-csv.type';

/*
 * ImportCsvSteps Component
 *
 * Pure component that renders the specific steps for the Import CSV process.
 * Receives all data and handlers as props from the parent ProcessImportCsv component.
 */
export const ImportCsvSteps: React.FC<ImportCsvStepsProps> = ({
  step,
  setStep,
  offer,
  fileName,
  rows,
  setRows,
  setFileName,
  localQrCodeIssues,
  onContinueReviewImport,
  onContinueConfirmImport,
  onClose,
}) => {
  return (
    <>
      {step === STEP_SELECT_TYPE && (
        <SelectType
          offer={offer}
          onContinue={() => setStep(STEP_INFO)}
          fileName={fileName}
          rows={rows}
          setRows={setRows}
          setFileName={setFileName}
        />
      )}
      {step === STEP_INFO && <ReviewImport columns={rows} onDiscard={onClose} onContinue={onContinueReviewImport} />}
      {step === STEP_CONFIRM && (
        <ConfirmImportCsv
          qrWarnings={localQrCodeIssues}
          onContinue={onContinueConfirmImport}
          onBack={() => setStep(STEP_INFO)}
        />
      )}
    </>
  );
};
